<div class="button-grid" [ngClass]="gridKlasses">
  @for(item of menuItems; track item.id) {
    <pv2-button-menu-item [item]="item"></pv2-button-menu-item>
  }
</div>
